<ng-container [ngSwitch]="true">
  <div *ngSwitchCase="''">

  </div>
  <div *ngSwitchDefault><NS-user-login></NS-user-login></div>
</ng-container>